import React from "react";
import { NavLink } from "react-router-dom";
import { TOOLKIT_TOOLS } from "Pages/Dashboard/data-toolkit/constants";
import ToolIcon from "Pages/Dashboard/data-toolkit/ToolIcon";

const DataToolkitNav = () => (
  <div className="dtNav">
    <div className="dtNavTitle">Tools</div>
    {TOOLKIT_TOOLS.filter(tool => !tool.hidden).map(tool =>
      tool.available ? (
        <NavLink
          key={tool.key}
          to={tool.path}
          className="dtNavItem"
          activeClassName="active"
        >
          <span className="dtNavIcon">
            <ToolIcon name={tool.key} size={19} />
          </span>
          <span className="dtNavLabel">{tool.title}</span>
        </NavLink>
      ) : (
        <div key={tool.key} className="dtNavItem disabled">
          <span className="dtNavIcon">
            <ToolIcon name={tool.key} size={19} />
          </span>
          <span className="dtNavLabel">{tool.title}</span>
          <span className="dtNavBadge">Soon</span>
        </div>
      )
    )}
  </div>
);

export default DataToolkitNav;
